import { render, staticRenderFns } from "./JuliangUpload.vue?vue&type=template&id=6a27edc1&scoped=true"
import script from "./JuliangUpload.vue?vue&type=script&lang=js"
export * from "./JuliangUpload.vue?vue&type=script&lang=js"
import style0 from "./JuliangUpload.vue?vue&type=style&index=0&id=6a27edc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27edc1",
  null
  
)

export default component.exports